mainApp.service('EntityTypesService', ['TranslationService', function(TranslationService) {
	var dataForAccount; // since site types can be different for different account,
						// don't use cache if requesting types for a different account than we have data for
	var siteTypes;

	return {
		getSiteTypes: function(accountId, callback) {
			if (siteTypes && dataForAccount === accountId) {
				callback(siteTypes);
			} else {
				store.fetch({
					path: '/getSiteTypes?accountId=' + accountId,
					success: function(data) {
						dataForAccount = accountId;
						siteTypes = [];
						if (data) {
							data.forEach(function(item) {
								siteTypes.push({
									name: TranslationService.translate(item),
									value: item,
								});
							});
						}

						callback(siteTypes);
					}
				});
			}
		},
		clearCache: function() {
			siteTypes = [];
			dataForAccount = null;
		}
	};
}]);